// extracted by mini-css-extract-plugin
export var aiStarIcon = "_tn-2";
export var container = "_tn-4";
export var dismissButton = "_tn-3";
export var hasPaddingBottom = "_tn-6";
export var last = "_tn-e";
export var scrollbarThumb = "_tn-c";
export var scrollbarTrack = "_tn-b";
export var selected = "_tn-9";
export var spin = "_tn-1";
export var spinning = "_tn-0";
export var suggestionItem = "_tn-d";
export var suggestionsPanel = "_tn-5";
export var tonePill = "_tn-8";
export var tonesContainer = "_tn-7";
export var unselected = "_tn-a";